import { useEffect } from 'react';

import { MdsCallKeys, RBChannel } from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';
import { RequestStatus } from 'store/utils';

import { NowNextData } from 'services/data-manager/types';

import { RailLoadingStatus } from 'screens/Modular/types';

type Params = {
    stripeId: string;
    mdsCall: MdsCallKeys | undefined;
    requestStatus: RequestStatus;
    responseData: NowNextData[] | RBChannel[] | RecordingItem[];
    onSetStripeLoadingStatus(stripeId: string, status: RailLoadingStatus): void;
};

function useMdsStripeLoadingStatus({
    stripeId,
    mdsCall,
    requestStatus,
    responseData,
    onSetStripeLoadingStatus,
}: Params) {
    useEffect(() => {
        if (mdsCall && mdsCall === MdsCallKeys.CHANNELS) {
            if (requestStatus === RequestStatus.PENDING) {
                onSetStripeLoadingStatus(stripeId, RailLoadingStatus.LOADING);
            } else if (requestStatus === RequestStatus.FAILURE) {
                onSetStripeLoadingStatus(stripeId, RailLoadingStatus.FAILURE);
            } else if (
                requestStatus === RequestStatus.SUCCESS &&
                !responseData.length
            ) {
                onSetStripeLoadingStatus(stripeId, RailLoadingStatus.EMPTY);
            } else if (
                requestStatus === RequestStatus.SUCCESS &&
                responseData.length
            ) {
                onSetStripeLoadingStatus(stripeId, RailLoadingStatus.LOADED);
            }
        }
    }, [mdsCall, requestStatus, responseData.length]);
}

export default useMdsStripeLoadingStatus;
